<template>
    <div>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <strong>{{$t('components.addSaleMethod')}}</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CRow>


                          <CCol >
                            <CInput
                                :label="$t('components.methodName')"
                                horizontal
                                v-model="name"

                            />
                          </CCol>
                          <CCol >
                            <CInput
                                :label="$t('components.color')"

                                type="color"
                                v-model="color"

                                horizontal
                            />

                          </CCol>



                        </CRow>
                    </CCardBody>
                    <CCardFooter>
                        <CButton v-if="status_form==0" @click="insert_data()" type="submit" size="sm" color="primary">
                            <CIcon name="cil-check-circle"/>
                            {{$t('buttons.addMethod')}}
                        </CButton>
                      <CButton v-if="status_form!=0" @click="insert_data()" type="submit" size="sm" color="success">
                            <CIcon name="cil-check-circle"/>
                            {{$t('buttons.editMethod')}}
                        </CButton>

                        <CButton v-if="status_form!=0" @click="emptyList()" type="reset" size="sm" color="danger">
                            <CIcon name="cil-ban"/>
                            {{$t('buttons.emptyForm')}}
                        </CButton>

                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>
        <CRow>
            <CCol md="12">
                <CCard>
                    <CCardHeader>
                        <strong>{{$t('components.saleMethods')}}</strong>
                    </CCardHeader>
                    <CCardBody>
                        <CDataTable
                                :items="items"
                                :fields="fields"

                                :items-per-page="20"
                                hover
                                sorter
                                pagination
                        >
                            <template #row="{item}">

                                <td>
                                    <p >{{item.row_id+1}}</p>

                                </td>

                            </template>
                            <template #name="{item}">

                                <td>
                                    <p >{{item.title}}</p>

                                </td>

                            </template>

                          <template #color="{item}">

                            <td>
                              <div :style="get_style(item.methodColor)">
                                {{ item.methodColor }}
                              </div>
                            </td>

                          </template>
                            <template #operation="{item}">
                                <td>
                                  <CButton
                                      class="m-1"
                                      color="success"
                                      variant="outline"
                                      square
                                      size="sm"
                                      :title="$t('buttons.members')"
                                      @click="goToMembers(item)"
                                  ><CIcon name="cil-people" />
                                  </CButton>
                                  <CButton
                                      class="m-1"
                                      color="warning"
                                      variant="outline"
                                      square
                                      size="sm"
                                      :title="$t('buttons.delete')"
                                      @click="edit_item(item)"
                                  ><CIcon name="cilPencil" />
                                  </CButton>
                                    <CButton
                                            class="m-1"
                                            color="danger"
                                            variant="outline"
                                            square
                                            size="sm"
                                            :title="$t('buttons.delete')"
                                            @click="delete_item_dialog(item)"
                                    ><CIcon name="cilTrash" />
                                    </CButton>

                                </td>
                            </template>


                        </CDataTable>
                    </CCardBody>
                    <CCardFooter>

                    </CCardFooter>
                </CCard>
            </CCol>
        </CRow>

    </div>
</template>

<script>
    import axios from "axios";
    import {bus} from '../../../main';
    // import the styles

    var items = [];




    export default {
        name: 'Login',
        components: {
        },
        data() {
            return {

                validate_errors: [],
                name: '',
                file: '',
                color: '#ffffff',
                previewImage: '',
                description: '',
                items: items.map((item, row_id) => {
                    return {...item, row_id}
                }),
                fields : [
                    {key: 'row',label:this.$t('tables.row'), _style: 'width:10%'},
                    {key: 'name',label:this.$t('tables.name'), _style: 'width:10%'},
                    {key: 'color',label:this.$t('tables.name'), _style: 'width:10%'},
                    {key: 'operation',label:this.$t('tables.operation'), _style: 'width:20%;'},
                ],

                document_product: null,

                details: [],
                collapseDuration: 0,
                status_form: 0,

            }
        },
        created() {
        },
        mounted() {
            this.$root.root_validate_errors = [];


            this.get_lists();
            bus.$on('delete_method_confirm', (data) => {
                // alert(data);
                if (data == "true") {
                    this.delete_item();

                } else {
                    this.status_form = 0;
                }
            });
        }, watch: {
            '$route.params.cat_id': function () {
                this.get_lists();
            },
            'selected_province': function () {
                console.log("peovince changed");
                this.get_cities();
            },
            'selected_city': function () {
                this.get_areas();
            }
        },
        methods: {
            validateForm: function () {
                this.$root.root_validate_errors = [];

                if (this.document_person != '' && this.selected_area != 0) {
                    return true;
                }


                // if (this.document_person == '') {
                //     this.$root.root_validate_errors.push('نام ویزیتور را وارد کنید');
                // }
                // if (this.selected_area == 0) {
                //     this.$root.root_validate_errors.push('محله را انتخاب کنید');
                // }

                return false;
                // e.preventDefault();
            },

            get_style(color) {
                return {
                    myStyle: {
                        backgroundColor: color
                    }
                }
            },
            edit_item(item) {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = item.title;
                this.color = item.methodColor;

                this.status_form = item.id;
                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            emptyList() {
                // this.$set(this.items[item.id], '_toggled', !item._toggled)
                this.name = '';
                this.color = '';
                this.description = '';
                this.previewImage = '';
                this.status_form = 0;

                // this.$nextTick(() => {
                //     this.collapseDuration = 0
                // })
            },
            get_lists() {
                var self = this;

                const formData = new FormData();


                // formData.append('id', this.selected_province);


                axios.post('GetPriceMethodTitles', formData, {

                }).then(function (response) {

                    var content_data = response.data;

                    // items = content_cats.orders;
                    if (content_data.statusCode == 0) {
                        self.items = content_data.data.map((item, row_id) => {
                            return {...item, row_id}
                        });
                    } else {
                        self.$root.modal_component.show_danger_modal(self.$t('dialogs.error'), content_data.message);

                    }


                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            goToMembers(item) {

                this.$router.push({path: '/dashboard/accounting/sale-method-members/' + item.id});
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },

            insert_data() {

                if (!this.validateForm()) {
                    console.log("validate form is false" + this.validate_errors);
                    return true;
                }
                let self = this;
                const formData = new FormData();
                let url;
                if (this.status_form == 0) {
                    url = "AddMethodTitle";
                } else {
                    url = "EditMethodTitle";
                    formData.append('Id', this.status_form)

                }


                formData.append('Title', this.name);
                formData.append('MethodColor', this.color);
                // formData.append('AreaId', this.selected_area);
                axios.post(url, formData, {}).then((res) => {



                    self.status_form = 0;
                    self.name = '';
                    self.color = '';
                    self.description = '';
                    self.previewImage = '';
                    self.get_lists();

                    self.$root.modal_component.show_api_response_modals(res);

                })
                    .catch(function (error) {

                        console.log(error);
                    });

            },
            delete_item_dialog(item) {

                this.$root.modal_component.show_confirm_modal(this.$t("dialogs.warning"), this.$t("dialogs.deleteMessageParams", [item.title]), [this.$t("dialogs.ok")], 'delete_method_confirm');

                this.status_form = item.id;

            }, delete_item() {


                let self = this;
                const formData = new FormData()
                let url;
                url = "DeleteMethodTitle";


                formData.append('Id', this.status_form);

                axios.post(url, formData, {}).then((res) => {

                    self.$root.modal_component.show_api_response_modals(res);

                    self.status_form = 0;

                    self.get_lists();


                })
                    .catch(function (error) {

                        console.log(error);
                    });
// this.get_categories();
                // this.$router.push({ path: '/posts/'});
            },
        }
    }

</script>
